import React, { useEffect, useState } from "react";
import { Buttton } from "../../components";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const AppLayoutOne = ({ leftSide, rightSide }) => {
    const [isExpanded, setIsExpanded] = useState(true);
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 992) {
                setIsExpanded(false);
            }
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const toggleLeftSide = () => {
        if (window.innerWidth > 992) {
            setIsExpanded((prev) => !prev);
        }
    };
    const handleMouseEnter = () => {
        if (window.innerWidth > 992) {
            setIsExpanded(false);
        }
    };

    return (
        <section
            className={`appLayout-wrapper ${isExpanded ? "collapsed" : "expanded"}`}
        >
            <aside className="l-side">
                {isExpanded ? (
                    <div className="w-100 h-100" onMouseEnter={handleMouseEnter}></div>
                ) : (
                    <div className="l-side-scroll">{leftSide}</div>
                )}
                <div className="side-expand-btn-blk">
                    <Buttton.Buttton
                        children={isExpanded ? <IoIosArrowForward /> : <IoIosArrowBack />}
                        className="side-expand-btn"
                        onClick={toggleLeftSide}
                    />
                </div>
            </aside>
            <aside className="r-side">
                <div className="r-side-scroll">{rightSide}</div>
            </aside>
        </section>
    );
};

export default AppLayoutOne;
